import styled from "styled-components";

export const Container = styled.div`
    /* preenche toda a área do TabScreen (que centraliza o conteúdo por padrão) */
    align-self: stretch;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 18px 22px 90px;
    font-family: Mulish;

    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-thumb { background-color: #BABABA; border-radius: 5px; }
`;

export const State = styled.div`
    padding: 40px 12px;
    text-align: center;
    color: #8A94A6;
    font-size: 0.9rem;
`;

export const Banner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #FFF8E6;
    border: 1px solid #F6E7B8;
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 16px;
`;
// Ícone de alerta (círculo laranja + triângulo branco) — usado no banner e no aviso do behavior.
export const WarnIcon = styled.span`
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${(p) => (p.$sm ? "18px" : "24px")};
    height: ${(p) => (p.$sm ? "18px" : "24px")};
    border-radius: 50%;
    background: #F59E0B;
    color: #FFFFFF;
    svg { font-size: ${(p) => (p.$sm ? "0.7rem" : "0.9rem")}; }
`;
export const BannerText = styled.div`color: #8A5A1B;`;
export const BannerTitle = styled.div`font-weight: 800; font-size: 0.9rem; margin-bottom: 2px;`;
export const BannerBody = styled.div`
    font-size: 0.84rem; font-weight: 600; line-height: 1.4; color: #A06A22;
    b { font-weight: 800; color: #8A5A1B; }
`;

export const Card = styled.div`
    background: #FFFFFF;
    border: 1px solid #EEF1F6;
    border-radius: 14px;
    padding: 18px 20px;
    margin-bottom: 16px;
`;

export const CardHead = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
`;

export const CardTitle = styled.h3`
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
    color: #2B3240;
`;

export const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #EEF1F6;
    color: #6B7280;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 12px;
    white-space: nowrap;
    svg { font-size: 0.9rem; }
`;

export const IdentityRow = styled.div`
    display: flex;
    gap: 22px;
`;

export const PhotoCol = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

export const Avatar = styled.div`
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: ${(props) => props.$color || "#2F80ED"};
    ${(props) => props.$image && `background-image: url(${props.$image}); background-size: cover; background-position: center;`}
    color: #FFFFFF;
    font-weight: 700;
    font-size: 1.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const HiddenFileInput = styled.input`
    display: none;
`;

export const PhotoBtn = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: #384250;
    color: #FFFFFF;
    font-family: Mulish;
    font-size: 0.78rem;
    font-weight: 700;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;

    &:disabled { opacity: 0.55; cursor: not-allowed; }
`;

export const RemoveBtn = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    border: none;
    background: transparent;
    color: #EF4444;
    font-family: Mulish;
    font-size: 0.76rem;
    font-weight: 700;
    cursor: pointer;

    &:disabled { opacity: 0.55; cursor: not-allowed; }
`;

export const Fields = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-size: 0.82rem;
    font-weight: 700;
    color: #2B3240;
    margin-bottom: 6px;
`;

export const InputWrap = styled.div`
    position: relative;
`;

export const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #E3E8F0;
    border-radius: 8px;
    padding: 10px 52px 10px 12px;
    font-family: Mulish;
    font-size: 0.88rem;
    font-weight: 600;
    color: #2B3240;
    background: #F7F9FC;

    &:focus { outline: none; border-color: #2F80ED; }
`;

export const Counter = styled.span`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9AA4B2;
    font-size: 0.72rem;
`;

// Contador da textarea (multi-linha) — bloco alinhado à direita, abaixo do campo.
export const TextareaCounter = styled.span`
    display: block;
    text-align: right;
    color: #9AA4B2;
    font-size: 0.72rem;
    margin-top: 4px;
`;
// Linha contador + hint sob a textarea (mesma linha) — evita o espaço vazio da linha extra.
export const MetaRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 4px;
    > * { margin-top: 0; }
`;

export const Hint = styled.span`
    color: #9AA4B2;
    font-size: 0.72rem;
    margin-top: 5px;
`;

export const Textarea = styled.textarea`
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #E3E8F0;
    border-radius: 8px;
    padding: 10px 12px;
    font-family: Mulish;
    font-size: 0.88rem;
    font-weight: 600;
    color: #2B3240;
    background: #F7F9FC;
    resize: vertical;

    &:focus { outline: none; border-color: #2F80ED; }
`;

export const ComingSoon = styled.div`
    color: #B7BEC9;
    font-size: 0.82rem;
    font-style: italic;
`;

export const PinnedHead = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #EEF1F6;
`;

export const PinnedIcon = styled.div`
    flex: 0 0 auto;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #2F80ED;
    color: #FFFFFF;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PinnedHeadText = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CardSubtitle = styled.span`
    color: #8A94A6;
    font-size: 0.8rem;
    margin-top: 3px;
`;

export const PinnedList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const PinnedItem = styled.div`
    background: #F2F5FB;
    border-radius: 10px;
    padding: 12px 14px;
`;

export const PinnedFrom = styled.span`
    display: block;
    font-size: 0.76rem;
    font-weight: 700;
    color: #2F80ED;
    margin-bottom: 3px;
`;

export const PinnedText = styled.span`
    font-size: 0.86rem;
    color: #2B3240;
    white-space: pre-wrap;
    word-break: break-word;
`;

export const PinnedEmpty = styled.div`
    color: #9AA4B2;
    font-size: 0.82rem;
    padding: 4px 2px;
`;

export const BehaviorRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 0;
    border-bottom: 1px solid #F2F4F8;
`;

export const BehaviorInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

export const BehaviorName = styled.span`
    font-size: 0.86rem;
    font-weight: 700;
    color: #2B3240;
`;

export const BehaviorDesc = styled.span`
    font-size: 0.74rem;
    color: #9AA4B2;
    margin-top: 2px;
`;

export const WelcomeNote = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    background: #FFF7E6;
    border: 1px solid #FFE1A8;
    color: #8A6D3B;
    font-size: 0.74rem;
    line-height: 1.4;
`;

export const GroupStateHint = styled.div`
    margin-top: 4px;
    font-size: 0.72rem;
    font-weight: 700;
    color: #2F80ED;
`;

// Toggle agora é o componente compartilhado ../../Components/Toggle.

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border: 1px solid #EEF1F6;
    border-radius: 14px;
    padding: 14px 18px;
`;

export const FooterNote = styled.span`
    color: #9AA4B2;
    font-size: 0.8rem;
`;

export const Actions = styled.div`
    display: flex;
    gap: 10px;
`;

export const CancelBtn = styled.button`
    border: none;
    background: #384250;
    color: #FFFFFF;
    font-family: Mulish;
    font-size: 0.82rem;
    font-weight: 700;
    padding: 9px 18px;
    border-radius: 8px;
    cursor: pointer;

    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const SaveBtn = styled.button`
    border: none;
    background: #2F80ED;
    color: #FFFFFF;
    font-family: Mulish;
    font-size: 0.82rem;
    font-weight: 700;
    padding: 9px 22px;
    border-radius: 8px;
    cursor: pointer;

    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
